import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import SmartphoneIcon from "@mui/icons-material/Smartphone";

import AppsContainer from "@crema/core/AppsContainer";
import AppInfoView from "@crema/core/AppInfoView";
import { getAllSyncGIS, getAllSyncPlan } from "redux/actions";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
const SyncData = () => {
  const { messages } = useIntl();
  const dispatch = useDispatch();

  const [lastClickedDatePlan, setLastClickedDatePlan] = useState<string>(
    localStorage.getItem("lastClickedDatePlan") || ""
  );
  const [lastClickedDateGIS, setLastClickedDateGIS] = useState<string>(
    localStorage.getItem("lastClickedDateGIS") || ""
  );

  const [openDialog, setOpenDialog] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  useEffect(() => {
    setLastClickedDatePlan(localStorage.getItem("lastClickedDatePlan") || "");
    setLastClickedDateGIS(localStorage.getItem("lastClickedDateGIS") || "");
  }, []);

  const handleDialogClose = () => setOpenDialog(false);

  const handleSyncPlans = async () => {
  const dateStr = new Date().toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  try {
    const result = await dispatch<any>(getAllSyncPlan());
    if (result.success) {
      setLastClickedDatePlan(dateStr);
      localStorage.setItem("lastClickedDatePlan", dateStr);
      setDialogMessage("Plan sync update successful!");
      setOpenDialog(true);
    }
  } catch (error) {
    setDialogMessage("Plan sync failed. Please try again.");
    setOpenDialog(true);
    console.error("Plan sync error:", error);
  }
};

const handleSyncGIS = async () => {
  const dateStr = new Date().toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  try {
    const result = await dispatch<any>(getAllSyncGIS());
    if (result.success) {
      setLastClickedDateGIS(dateStr);
      localStorage.setItem("lastClickedDateGIS", dateStr);
      setDialogMessage("GIS sync update successful!");
      setOpenDialog(true);
    }
  } catch (error) {
    setDialogMessage("GIS sync failed. Please try again.");
    setOpenDialog(true);
    console.error("GIS sync error:", error);
  }
};

  return (
    <>
      <AppsContainer
        title={
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: 16,
                fontWeight: "bold",
                color: "text.primary",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {messages["sidebar.syncMaster"] || "Sync Master"}
            </Box>
          </Box>
        }
        fullView
      >
        <Box
          sx={{
            backgroundColor: "#ffffff",
            padding: 8,
            width: "100%",
            display: "flex",
            gap: 4,
            flexWrap: "wrap",
          }}
        >
          {/* Plan Box */}
          <Box
            sx={{
              width: 250,
              bgcolor: "#fff",
              borderRadius: 3,
              boxShadow: 2,
              p: 3,
              position: "relative",
              cursor: "pointer",
            }}
            onClick={handleSyncPlans}
          >
            <Avatar
              sx={{
                bgcolor: "#e91e63",
                position: "absolute",
                top: -20,
                left: 20,
                width: 40,
                height: 40,
              }}
            >
              <SmartphoneIcon />
            </Avatar>
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" fontWeight="bold">
                Plan
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Last Sync: {lastClickedDatePlan || "Not yet synced"}
              </Typography>
            </Box>
          </Box>

          {/* GIS Box */}
          <Box
            sx={{
              width: 250,
              bgcolor: "#fff",
              borderRadius: 3,
              boxShadow: 2,
              p: 3,
              position: "relative",
              cursor: "pointer",
            }}
            onClick={handleSyncGIS}
          >
            <Avatar
              sx={{
                bgcolor: "#f06039",
                position: "absolute",
                top: -20,
                left: 20,
                width: 40,
                height: 40,
              }}
            >
              <SmartphoneIcon />
            </Avatar>
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" fontWeight="bold">
                Sync GIS
              </Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Last Sync: {lastClickedDateGIS || "Not yet synced"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </AppsContainer>

      {/* Success Dialog */}
    <Dialog
  open={openDialog}
  onClose={handleDialogClose}
  PaperProps={{
    sx: {
      borderRadius: 3,
      p: 2,
      width: 360,
      boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
    },
  }}
>
  <DialogTitle
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 1,
      textAlign: "center",
      pb: 0,
    }}
  >
    {dialogMessage?.toLowerCase().includes("success") ? (
      <CheckCircleOutlineIcon sx={{ color: "#4caf50", fontSize: 48 }} />
    ) : (
      <ErrorOutlineIcon sx={{ color: "#f44336", fontSize: 48 }} />
    )}
    <Typography
      variant="h6"
      sx={{ fontWeight: 600, mt: 1, color: "text.primary" }}
    >
      {dialogMessage?.toLowerCase().includes("success")
        ? "Sync Successful"
        : "Sync Failed"}
    </Typography>
  </DialogTitle>

  <DialogContent sx={{ textAlign: "center", pt: 1 }}>
    <Typography variant="body2" color="text.secondary">
      {dialogMessage}
    </Typography>
  </DialogContent>

  <DialogActions
    sx={{
      display: "flex",
      justifyContent: "center",
      pb: 2,
    }}
  >
    <Button
      onClick={handleDialogClose}
      variant="contained"
      color={
        dialogMessage?.toLowerCase().includes("success")
          ? "success"
          : "error"
      }
      sx={{
        px: 4,
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 2,
      }}
    >
      OK
    </Button>
  </DialogActions>
</Dialog>

      <AppInfoView />
    </>
  );
};

export default SyncData;
